/**
 * Where a new account goes after the shared phone-apps step.
 * The next path has to be a same-app path. Login, signup, and the
 * step itself are not destinations.
 */

import { accountNeedsSetup, isSetupPath } from './accountSetup';

export function safeNext(value) {
  if (typeof value !== 'string') return '';
  const raw = value.trim();
  if (!raw.startsWith('/') || raw.startsWith('//') || raw.includes('://') || raw.includes('\\')) return '';
  const path = raw.split('?')[0].split('#')[0];
  if (path === '/welcome/apps' || path === '/login' || path === '/signup') return '';
  return raw;
}

export function afterPhoneAppsPath(next, user) {
  const safe = safeNext(next || '');
  const needsSetup = accountNeedsSetup(user);
  if (safe && (needsSetup || !isSetupPath(safe))) return safe;
  return needsSetup ? '/onboarding' : '/';
}
